import { WaitMusic } from 'lib-shared-types-api';

import type { Announcement } from 'apis/uploads';

export function isAnnouncement(
  file: Announcement | WaitMusic | undefined,
): file is Announcement {
  return (file as Announcement | undefined)?.resource_type === 'announcement';
}
